if(templateSiteSelected == 'Brand'){
    (function(){
        let linksOffers = {
            "2400": {
                "property": "Oxford Suites Chico",
                "url": 'https://reservations.oxfordsuiteschico.com/106548'
            },
            "2402": {
                "property": 'Oxford Suites Bellingham',
                "url": 'https://reservations.oxfordsuitesbellingham.com/106574'
            },
            "2403": {
                "property": 'Oxford Suites Boise',
                "url": 'https://reservations.oxfordsuitesboise.com/106568'
            },
            "2404": {
                "property": 'Oxford Suites Hermiston',
                "url": 'https://reservations.oxfordsuiteshermiston.com/106566'
            },
            "2405": {
                "property": 'Oxford Suites Lancaster',
                "url": 'https://reservations.oxfordsuiteslancaster.com/106559'
            },
            "2406": {
                "property": 'Oxford Suites Paso Robles',
                "url": 'https://reservations.oxfordsuitespasorobles.com/106633'
            },
            "2407": {
                "property": 'Oxford Suites Pendleton',
                "url": 'https://reservations.oxfordsuitespendleton.com/106565'
            },
            "2408": {
                "property": 'Oxford Suites Pismo Beach',
                "url": 'http://reservations.oxfordsuitespismobeach.com/106557'
            },
            "2409": {
                "property": 'Oxford Suites Portland',
                "url": 'https://reservations.oxfordsuitesportland.com/106554'
            },
            "2410": {
                "property": 'Oxford Suites Redding',
                "url": 'https://reservations.oxfordsuitesredding.com/106563'
            },
            "2411": {
                "property": 'Oxford Suites Silverdale',
                "url": 'https://reservations.oxfordsuitessilverdale.com/106570'
            },
            "2412": {
                "property": 'Oxford Suites Sonoma County',
                "url": 'https://reservations.oxfordsuitessonoma.com/106575'
            },
            "2413": {
                "property": 'Oxford Suites Spokane',
                "url": 'https://reservations.oxfordsuitesspokane.com/106561'
            },
            "2414": {
                "property": 'Oxford Suites Spokane Valley',
                "url": 'https://reservations.oxfordsuitesspokanevalley.com/106552'
            },
            "2416": {
                "property": 'Oxford Suites Yakima',
                "url": 'https://reservations.oxfordsuitesyakima.com/106556'
            }
        }
        
        console.log(templateSiteSelected);    
        ////***** BOOKING WIDGET BRAND *****////
        if(document.getElementById('container-booking-widget-brand')){
            let actualDay = new Date();
            let actualDayMore = new Date();
            actualDayMore.setDate(actualDay.getDate() + 3);	
            let checkInBooking = document.getElementById('check-in');
            let checkOutBooking = document.getElementById('check-out');
            let selectPropertyBooking = document.getElementById('select_property_booking');
            let bookingWidget = document.getElementById('booking-widget-brand');
    
            flatpickr.localize({
                rangeSeparator: " - "
            });
            
            flatpickr("#dates_fake_booking", {
                showMonths: 2,
                minDate : actualDay,
                mode: 'range',
                dateFormat: 'm/d/Y',
                allowInput: true,
                defaultDate: {actualDay, actualDayMore},
                onChange: function(selectedDates, dateStr, instance) {
                    let dates = dateStr.split('-');
                    checkInBooking.value = dates[0].trim();
                    checkOutBooking.value = dates[1].trim();
                }
            });
            
            selectPropertyBooking.addEventListener('change', ()=>{
                let newUrl = selectPropertyBooking.value;
                bookingWidget.setAttribute('action', newUrl);
            })
        }
    
        if(document.querySelector('.homepage-background')){
            let heightQuadOffers = window.innerWidth > 600 ? document.querySelector('.featured-offer').offsetHeight - 90 : document.querySelector('.featured-offer').offsetHeight;
            let background = document.createElement('div');
            background.classList.add('background-home-div');
            background.setAttribute('aria-hidden', 'true');
            document.querySelector('.homepage-background').appendChild(background);
            background.style.top = heightQuadOffers+'px';
            background.style.height = 'calc(100% - '+ (heightQuadOffers + 450) +'px)';
        }

        if(document.querySelector('.offers-quad')){
            let allOffersQuad = document.querySelectorAll('.offers-quad');

            allOffersQuad.forEach((quad)=>{
                let formsOffers = quad.querySelectorAll('.offers-quad__item .offers-quad__select');
                formsOffers.forEach((form)=>{
                    form.querySelector('.select-properies-offer').addEventListener('change', (e)=>{
                        let subscription = e.target.value;
                        form.setAttribute('action', linksOffers[subscription].url);
                        console.log(linksOffers[subscription].url);
                    })
                })
            })
        }

        if(document.getElementById('booking-widget-main')){
            let actualDay2 = new Date();
            let actualDayMore2 = new Date();
            actualDayMore2.setDate(actualDay2.getDate() + 3);	
            let checkInBooking = document.getElementById('check-in-main');
            let checkOutBooking = document.getElementById('check-out-main');
            let selectPropertyBooking = document.getElementById('select_property_booking-main');
            let bookingWidget = document.getElementById('booking-widget-main');
    
            flatpickr.localize({
                rangeSeparator: " - "
            });
            
            flatpickr("#dates_fake_booking_main", {
                showMonths: 1,
                minDate : actualDay2,
                mode: 'range',
                dateFormat: 'm/d/Y',
                inline: true,
                defaultDate: {actualDay2, actualDayMore2},
                onDayCreate: function(dObj, dStr, fp, dayElem) {
                    if (dayElem.classList.contains("startRange")) {
                        const text = `<sup>ARRIVE</sup>`;
                        dayElem.insertAdjacentHTML("beforeend", text)
                    }
                    if (dayElem.classList.contains("endRange")) {
                        const text = `<sup>DEPART</sup>`;
                        dayElem.insertAdjacentHTML("beforeend", text)
                    }
                },          
                onChange: function(selectedDates, dateStr, instance) {
                    let dates = dateStr.split('-');
                    checkInBooking.value = dates[0].trim();
                    checkOutBooking.value = dates[1].trim();
                },
                onReady: function(selectedDates, dateStr, instance) {
                    adaRemove()
                },
                onMonthChange: function(selectedDates, dateStr, instance) {
                    adaRemove()
                }          
            });
            
            selectPropertyBooking.addEventListener('change', ()=>{
                let newUrl = selectPropertyBooking.value;
                bookingWidget.setAttribute('action', newUrl);
                document.querySelector('.booking-main__left .select.property .msje-error').classList.remove('show');
            })

            //Remove aria-label for ADA
            function adaRemove() {
                let allDaysLabel = document.querySelectorAll(".flatpickr-days .flatpickr-day");
                allDaysLabel.forEach((day) => {
                day.removeAttribute("aria-label");
                })
            }

            document.querySelector('.js-open-main-bw').addEventListener('click',(e)=>{
                document.getElementById('booking-main').classList.add('show');
            })
            document.querySelector('.js-close-main').addEventListener('click', ()=>{
                document.getElementById('booking-main').classList.remove('show');
            })

            document.querySelector('.booking-main__bottom button').addEventListener('click',(e)=>{
                if (document.getElementById('select_property_booking-main').value == ''){
                    e.preventDefault();
                    document.querySelector('.booking-main__left .select.property').classList.add('required');
                    document.querySelector('.booking-main__left .select.property .msje-error').classList.add('show');
                    setTimeout(() => {
                        document.querySelector('.booking-main__left .select.property').classList.remove('required');
                    }, 600);
                }
            });

            if( document.querySelector('#container-booking-widget-brand')){
                document.querySelector('#container-booking-widget-brand button').addEventListener('click',(e)=>{
                    if (document.getElementById('select_property_booking').value == ''){
                        e.preventDefault();
                        document.querySelector('#booking-widget-brand .select.property .msje-error').classList.add('show');
                    }
                })
                document.querySelector('#container-booking-widget-brand #select_property_booking').addEventListener('change',()=>{
                    document.querySelector('#booking-widget-brand .select.property .msje-error').classList.remove('show');
                })
            }
        }
    })();
}